import React from "react";
import { useEffect, useState, useRef } from "react";

import { connect } from "react-redux";

import {
  searchPromotions,
  setPromotionsPageDefault,
} from "../../../redux/actions/promotions";
import { setAlert } from "../../../redux/actions/alerts";

import SearchDropdown from "../../Shared/SearchDropdown";

import styles from '../../../styles/pages/FeaturedContentPages/PromotionPageContent.module.css'

const TrashIcon = '/static/img/SvgIcons/icons-trash-black.svg';

const DefaultPromotionFormRow = ({
    index, 
    featured,
    handleChangeData,
    missingData,
    clear,
    clearFeaturedRow,
    searchPromotions,
    setAlert,
    promotion: {
        promotionSearchPage,
    },
}) => {
    const [existingContent, setExistingContent] = useState(null)

    useEffect(() => {
        setExistingContent(null)
    }, [clear])
 
    let timeout
    const searchForPromotions = (value) => {
        if (timeout) {
            clearTimeout(timeout)
        }

        if (!value) {
            return
        }

        timeout = setTimeout(() => {
        if (value.length < 3) {
            setAlert("Query must be 3 characters or longer", "danger");
        } else {
            searchPromotions(value);
        }
        }, 1000);
    };

    const handlePromotionSelect = (promotion) => {
        if (promotion) {
            handleChangeData({
                id: promotion.promotion_id,
                displayName: promotion.title
            },  index)
        } else {
            handleChangeData({
                id: null,
                displayName: null,
                name: null
            }, index)
        }
        setExistingContent(promotion)
    };
 

  return (
        <div className={`${styles.product_form_row_main_container} ${missingData ? styles.featured_form_row_error : ''}`}>
        
            {featured.name || featured.displayName || missingData ?
                <div className={styles.product_name_row_container}>
                    <>
                        {featured.name || featured.displayName ? 
                            <p>{featured.name ? 'Currently Featured' : 'To Be Added'}: {featured.name ? featured.name : featured.displayName} </p>
                        : 
                            <p>Remove Featured Row</p>
                        }
                        <img src={TrashIcon} alt="Trash Icon" onClick={() => clearFeaturedRow(index)} />
                    </>
                </div>
                : null
            }
                
            <div className={styles.form_input_row_grid}>
                
                <div className={`input_container ${styles.form_grid_span_5}  ${missingData && !existingContent ? styles.featured_form_input_error : ''}`}>
                    <label>Featured Promotion</label>
                    <SearchDropdown
                        options={promotionSearchPage?.length > 0 ?
                            promotionSearchPage.map((promotion) => ({
                                name: `${promotion.title}`,
                                value: promotion,
                            }))
                        : []}
                        placeholder={'Please start typing or use dropdown to search'} 
                        handleSelect={(option) => handlePromotionSelect(option)}
                        emptyOption={"No Options"}
                        selection={existingContent}
                        handleSearch={(searchString) => searchForPromotions(searchString)}
                    />
                </div> 
                
            </div>
        </div>
  )
  
};

const mapStateToProps = (state) => ({
  promotion: state.promotion,
});

export default connect(mapStateToProps, {
  searchPromotions,
  setAlert,
  setPromotionsPageDefault,
})(DefaultPromotionFormRow);
